module.exports = __webpack_public_path__ + "static/img/播放.d9057591.png";